import { Epic } from 'redux-observable';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { allPass, has, propEq } from 'ramda';
import { ofType } from '@alycecom/utils';

import { getShipping } from '../giftFlow/giftFlow.selectors';
import { getCountryById } from '../../../../store/countries/countries.selectors';

import { claimRequest, claimSuccess, claimFail, setShowResubscribeModal } from './claim.actions';
import { prepareClaimData } from './claim.helpers';
import { IClaimResponse } from './claim.types';
import { getIsResubscribeModalVisible } from './claim.selectors';

const checkUnsubscription = allPass([has('is_unsubscribed'), propEq('is_unsubscribed', true)]);

export const claimEpic: Epic = (action$, state$, { apiService, messagesService: { errorHandler } }) =>
  action$.pipe(
    ofType(claimRequest),
    withLatestFrom(state$),
    mergeMap(([{ payload: hashId }, state]) => {
      const giftFlowData = state.recipient.giftFlow ?? {};

      const shipping = getShipping(state);
      const country = getCountryById(shipping?.address.country || NaN)(state);
      const doResubscribe = getIsResubscribeModalVisible(state);

      const { hasIntegration = false } = state.recipient.statuses?.statuses;

      return apiService
        .post(`/api/recipient/${hashId}/claim`, {
          body: prepareClaimData(giftFlowData, { doResubscribe, hasIntegration }, country),
        })
        .pipe(
          map((payload: IClaimResponse) => claimSuccess(payload)),
          catchError(error => {
            const actions = checkUnsubscription(error) ? [claimFail, () => setShowResubscribeModal(true)] : [claimFail];
            return errorHandler({ callbacks: actions, showErrorsAsGlobal: true })(error);
          }),
        );
    }),
  );

export const claimEpics = [claimEpic];
